<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
        <template #namaStatusPerpanjangKontrak-filter>
          <b-form-select v-model="filter.statusPerpanjangKontrak" :options="optionsStatusPerpanjangKontrak"></b-form-select>
        </template>
        <template #namaTanggalMulaiKontrak-filter>
          <date-picker style="width: 100%" v-model="filter.tanggalMulaiKontrak" format="DD MMMM YYYY"></date-picker>
        </template>
        <template #namaTanggalDibuatSurat-filter>
          <date-picker style="width: 100%" v-model="filter.tanggalDibuatSurat" format="DD MMMM YYYY"></date-picker>
        </template>
        <template #Actions="{ item }">
          <td>
            <b-button
              v-if="item.statusPerpanjangKontrak == 0"
              variant="success"
              class="mr-1"
              v-c-tooltip.hover.click="'Aktifkan Mutasi'"
              v-b-modal.modal-aktivasi-renew
              @click="data = item"
              :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
              ><CIcon name="cil-check"
            /></b-button>
            <b-button
              v-if="item.statusPerpanjangKontrak == 0"
              variant="danger"
              class="mr-1"
              v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
              v-b-modal.modal-delete-perpanjang
              @click="data = item"
              :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
              ><CIcon name="cil-trash"
            /></b-button>
          </td>
        </template>
      </CDataTable>
      <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
    </CCol>
    <CCol col="12">
      <b-modal id="modal-aktivasi-renew" size="lg" centered scrollable title="Konfirmasi Perpanjang" header-bg-variant="info" header-text-variant="light">
        <p>
          Apakah anda yakin akan Memperpanjang Kontrak a.n
          <span class="text-success">{{ data.namaKaryawan }}</span>
          <!-- <span class="text-success" v-if="data.jenisMutasi == 'Jabatan'">{{data.jabatanAwal}}</span>
          <span class="text-success" v-if="data.jenisMutasi == 'Penempatan'">{{data.penempatanAwal}}</span>
          ke
          <span class="text-success" v-if="data.jenisMutasi == 'Jabatan'">{{data.jabatanBaru}}</span>
          <span class="text-success" v-if="data.jenisMutasi == 'Penempatan'">{{data.penempatanBaru}}</span> -->
          ?
        </p>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-aktivasi-renew')"> Batal </b-button>
          <b-button variant="primary" @click="aktifkan()" :disabled="busy"> Yakin </b-button>
        </template></b-modal
      >
      <b-modal id="modal-delete-perpanjang" size="lg" centered scrollable title="Konfirmasi Hapus Perpanjangan" header-bg-variant="info" header-text-variant="light">
        <p>
          Apakah anda yakin akan
          <span class="text-danger">Membatalkan</span> Perpanjangan Kontrak a.n
          <span class="text-danger">{{ data.namaKaryawan }}</span>
          ?
        </p>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-delete-perpanjang')"> Batal </b-button>
          <b-button variant="primary" @click="hapusMutasi()" :disabled="busy"> Yakin </b-button>
        </template></b-modal
      >
    </CCol>
  </CRow>
</template>

<script>
export default {
  components: {},
  name: "perpanjang",
  props: ["refresh"],
  data() {
    return {
      busy: false,
      data: {},
      items: [],

      filter: {
        statusPerpanjangKontrak: null,
        tanggalMulaiKontrak: null,
        tanggalDibuatSurat: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPerpanjangKontrak: [
        { value: null, text: "pilih" },
        { value: "0", text: "Non Aktif" },
        { value: "1", text: "Aktif" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 24%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "nomorSuratPerjanjian",
          label: this.$store.state.table.nomorSurat,
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalMulaiKontrak",
          label: this.$store.state.table.namaTanggalPerpanjang,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalDibuatSurat",
          label: this.$store.state.table.namaTanggalDibuatSurat,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusPerpanjangKontrak",
          label: this.$store.state.table.namaStatusPerpanjangKontrak,
          _style: "max-width: 14%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 8%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    this.getDatas();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusPerpanjangKontrak"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalMulaiKontrak"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalDibuatSurat"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    refresh(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPerpanjang = await vm.$axios.post("suratPerjanjianKerja/listPerpanjangKontrakPerHalaman", {
        ...vm.filter,
        tanggalMulaiKontrak: vm.filter.tanggalMulaiKontrak ? vm.$moment(vm.filter.tanggalMulaiKontrak).format("YYYY-MM-DD") : null,
        tanggalDibuatSurat: vm.filter.tanggalDibuatSurat ? vm.$moment(vm.filter.tanggalDibuatSurat).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listPerpanjang", listPerpanjang);
      vm.items =
        listPerpanjang.data.status == 200
          ? listPerpanjang.data.data.map((x, idx) => {
              vm.optionsStatusPerpanjangKontrak.forEach((item) => {
                if (x.statusPerpanjangKontrak == item.value) x.namaStatusPerpanjangKontrak = item.text;
              });
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.suratPerjanjianKerjaId,
                namaMitra: x.namaMitra || " - ",
                namaTanggalMulaiKontrak: vm.$moment(x.tanggalMulaiKontrak).format("LL"),
                namaTanggalDibuatSurat: vm.$moment(x.tanggalDibuatSurat).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(listPerpanjang.data.count);
      vm.loading = false;
    },
    aktifkan() {
      let vm = this;
      // console.log(vm.data, "aktif");
      vm.$axios
        .post("suratPerjanjianKerja/aktifkanPerpanjangPerjanjian", vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-aktivasi-renew");
              vm.busy = false;
              vm.getDatas();
              vm.$emit("change");
              vm.variant = "success";
              vm.triggerAlert({
                variant: "success",
                msg: "BERHASIL MENGAKTIFKAN PERPANJANGAN KONTRAK",
                showing: true,
              });
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.triggerAlert({
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: err.message,
            showing: true,
          });
        });
    },
    hapusMutasi() {
      let vm = this;
      // console.log(vm.data);
      vm.busy = true;
      vm.$axios
        .post("suratPerjanjianKerja/deletePerpanjangKontrak", vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-delete-perpanjang");
              vm.busy = false;
              vm.getDatas();
              vm.$emit("change");
              vm.triggerAlert({
                variant: "success",
                msg: "BERHASIL MEMBATALKAN PERPANJANG KONTRAK",
                showing: true,
              });
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.triggerAlert({
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: err.message,
            showing: true,
          });
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
